import { Note } from '../interfaces/note';
import { Deserializable } from './../deserializable';

export class AgentNote implements Note, Deserializable {
  public UserNoteID: number;
  public AgentNoteID: number;
  public AgentID?: number;
  public Notes: string;
  public CreatedDate?: Date;
  public CreatedBy: string;
  public Time: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Time = input.CreatedDate ? new Date(input.CreatedDate).getTime() : undefined;

    return this;
  }
}
